import React from 'react';
import { Row, Col, Alert, Clearfix, Button, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import EntityPropsUpdater from 'component/EntityPropsUpdater';
import FormSwitchery from '../../forms/FormSwitchery';
import may from '../../../security';
import _ from 'lodash';
import SimplePrompt from '../SimplePrompt';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ItemProvisionServiceNew from './ItemProvisionServiceNew';
import ItemProvisionServiceEdit from './ItemProvisionServiceEdit';
import {
  deleteServiceTypeItemR,
  getServiceTypesItemR,
  getServiceTypesR,
} from '../../../actions/ServiceTypesActions';
import Loader from '../Loader';
import IntlDateTime from '../IntlDateTime';

class ItemProvisionService extends EntityPropsUpdater {
  constructor(props) {
    super(props);
    this.state = {
      showNew: false,
      showEdit: false,
      serviceTypeId: '',
    };
  }

  componentDidMount = prevProps => {
    this.props.getServiceTypesItemR(this.props.entity?.data?.id);
    this.props.getServiceTypesR();
  };

  componentDidUpdate = prevProps => {};

  openAddProvisionService = () => {
    this.setState({ showNew: true });
  };

  closeAddProvisionService = () => {
    this.setState({ showNew: false });
  };

  openEditProvisionService = serviceTypeId => {
    this.setState({ serviceTypeId: serviceTypeId }, () => {
      this.setState({ showEdit: true });
    });
  };

  deleteProvisionService = id => {
    this.props.deleteServiceTypeItemR(id);
  };

  closeEditProvisionService = () => {
    this.setState({ showEdit: false });
  };

  translateTitle = i => {
    const index = _.findIndex(
      this.props.serviceTypesItemR[i].title,
      title => title.lang === this.props.appIntl.locale
    );
    return this.props.serviceTypesItemR[i].title[index].name; //or name
  };

  translateDescription = i => {
    const index = _.findIndex(
      this.props.serviceTypesItemR[i].description,
      descriptionR => descriptionR.lang === this.props.appIntl.locale
    );
    return this.props.serviceTypesItemR[i].description[index].description; //or name
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      disabled,
      user,
      serviceTypesItemR,
      item,
    } = this.props;

    const { showNew, showEdit, serviceTypeId } = this.state;
    const columns = [
      messages.provision_service_title,
      messages.provision_service_type,
      messages.provision_service_description_text,
      messages.primary_owner,
      messages.provision_service_primary_rate,
      messages.secondary_owner,
      messages.provision_service_secondary_rate,
      messages.provision_start,
      messages.provision_ending,
      messages.provision_service_type_status,
      messages.provision_actions,
    ];
    let tBody = [];
    let serviceTypesR = serviceTypesItemR; //[{id: "123", title: "serviceTypeTitel", type: "onboarding", rate1: "10%", rate2: "5%", owner1: "owner1", owner2: "owner2", provision_end: "12.10.2023" }]
    if (serviceTypesR && serviceTypesR.length > 0) {
      _.forEach(serviceTypesR, (serviceType, i) => {
        tBody.push(
          <tr
            key={i}
            class="clickable"
            style={{ backgroundColor: '#E1E0E3' }}
            onClick={() => this.openEditProvisionService(serviceType.id)}
          >
            <td class="v-align-middle">
              <span>{serviceType.name}</span>
            </td>
            <td className="v-align-middle">
              <span>{this.translateTitle(i)}</span>
            </td>
            <td className="v-align-middle">
              <span>{this.translateDescription(i)}</span>
            </td>
            <td className="v-align-middle">
              <p>
                <span>{serviceType?.primary_owner?.username || serviceType?.primaryOwner?.username}</span>
              </p>
              <p>
                <span>{serviceType?.primary_owner?.profile.company || serviceType?.primaryOwner?.profile.company}</span>
              </p>
            </td>
            <td className="v-align-middle">
              <span>{serviceType?.primary_rate || serviceType?.primaryRate}%</span>
            </td>
            <td className="v-align-middle">
              <p>
                <span>{serviceType?.secondary_owner?.username || serviceType?.secondaryOwner?.username} </span>
              </p>
              <p>
                <span>{serviceType?.secondary_owner?.profile.company || serviceType?.secondaryOwner?.profile.company}</span>
              </p>
            </td>
            <td className="v-align-middle">
              <span>{serviceType?.secondary_rate || serviceType?.secondaryRate}%</span>
            </td>
            <td className="v-align-middle">
              <span>
                <IntlDateTime date={serviceType.period_start || serviceType.periodStart} />
              </span>
            </td>
            <td className="v-align-middle">
              <span>
                <IntlDateTime date={serviceType.period_end || serviceType.periodEnd} />
              </span>
            </td>
            <td className="v-align-middle">
              <FormSwitchery
                name="status"
                label=""
                value
                checked={!!serviceType.is_active}
                onChange=""
                disabled="disabled"
              />
            </td>
            <td class="v-align-middle text-right">
              {may('ROLE_ADMIN', this.props.user.roles) && (
                <>
                  <SimplePrompt onSuccess={e => this.deleteProvisionService(serviceType.id)} />
                  <Button
                    onClick={() => this.openEditProvisionService(serviceType.id)}
                    bsStyle="warning"
                    className="pull-right m-l-10 m-t-10"
                    title="create_service_type"
                  >
                    <span className="hidden-xs">{messages.edit_provision_type}</span>
                  </Button>
                </>
              )}
            </td>
          </tr>
        );
      });
    }
    return (
      <div class="clearfix">
        {entityLoaded ? (
          <div>
            <Row>
              <Col style={{ textAlign: 'right' }}>
                <Button
                  onClick={() => this.openAddProvisionService()}
                  bsStyle="primary"
                  className="btn-rounded"
                  title="add_provision_service"
                  style={{ margin: '20px' }}
                >
                  <i className="fal fa-plus m-r-10 sm-m-r-0" />{' '}
                  <span className="hidden-xs">{messages.add_provision_service}</span>
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="padding-25 sm-padding-10">
                  {this.props.pending || this.props.pendingC ? (
                    <Loader />
                  ) : (
                    <Table responsive hover>
                      <thead>
                        <tr>
                          {columns.map((column, i) => {
                            return (
                              <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                                {column}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <ReactCSSTransitionGroup
                        transitionName="tablerows"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={1}
                        component="tbody"
                      >
                        {tBody}
                      </ReactCSSTransitionGroup>
                    </Table>
                  )}
                </div>
                <div id="subscription-new">
                  <ItemProvisionServiceNew
                    show={showNew}
                    close={this.closeAddProvisionService}
                    entity={entityLoaded && entity}
                    itemDetail={item}
                  />
                </div>

                <div id="subscription-edit">
                  <ItemProvisionServiceEdit
                    show={showEdit}
                    close={this.closeEditProvisionService}
                    entity={entityLoaded && entity}
                    itemDetail={item}
                    serviceTypeId={serviceTypeId}
                  />
                </div>
              </Col>
            </Row>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    appIntl: state.intl,
    serviceTypesR: state.provisionServiceTypes.serviceTypesR,
    serviceTypesItemR: state.provisionServiceTypes.serviceTypesItemR,
    pendingC: state.provisionServiceTypes.pendingC,
    pending: state.provisionServiceTypes.pending,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getServiceTypesItemR: (item) => {
      dispatch(getServiceTypesItemR(item));
    },
    deleteServiceTypeItemR: id => {
      dispatch(deleteServiceTypeItemR(id));
    },
    getServiceTypesR: () => {
      dispatch(getServiceTypesR());
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ItemProvisionService)
);
